module.exports = __webpack_public_path__ + "ship.png?84488c4f1c12c823c9d16cac6cc7450f";


//////////////////
// WEBPACK FOOTER
// ./src/kits/1/images/ship.png
// module id = 33
// module chunks = 0